var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-scroll-up"},[_c('div',{staticClass:"c-scroll-up__button",class:{'-active': _vm.active},on:{"click":_vm.onClick}},[_c('icon',{attrs:{"name":"chevron-up"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-280482fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/component/scroll-up.vue
// module id = 273
// module chunks = 1